

























import Vue from 'vue'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import AppDialog from '@/components/AppDialog.vue'

@Component({
  components: {
    AppDialog
  }
})
export default class QuoteRequestTypeDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean

  showDialog = false

  selectedIdx = 0
  options = ['Type In', 'Send Emails']

  @Watch('value')
  async valueChanged (val: boolean) {
    this.showDialog = val
  }

  actionHandler (idx: number) {
    this.selectedIdx = idx
  }

  @Emit('select')
  selectActionConfirm () {
    const { selectedIdx } = this
    this.hideDialog()
    this.selectedIdx = 0
    return selectedIdx
  }

  @Emit('input')
  hideDialog () {
    return false
  }
}
